import { API_URL } from '../../constants/constants';

/**
 * Syncs CMS content from Umbraco into PostgreSQL.
 * @param {string} token Firebase ID token
 * @returns {Promise<object>}
 */
export async function syncCms(token) {
  if (!token) {
    throw new Error('לא מחובר – אין טוקן אימות');
  }
  const res = await fetch(`${API_URL}/data/cms/sync`, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: 'application/json'
    }
  });
  if (!res.ok) {
    const text = await res.text().catch(() => '');
    const err = new Error(
      res.status === 403
        ? 'אין הרשאה לבצע סנכרון – נדרש משתמש אדמין.'
        : text || `שגיאת שרת (${res.status})`
    );
    err.status = res.status;
    throw err;
  }
  return res.json();
}

/**
 * Syncs CMS content from a provided Umbraco items payload.
 * @param {string} token Firebase ID token
 * @param {{ items: object[] }} payload
 * @returns {Promise<object>}
 */
export async function syncCmsFromBody(token, payload) {
  if (!token) {
    throw new Error('לא מחובר – אין טוקן אימות');
  }
  const res = await fetch(`${API_URL}/data/cms/sync/from-body`, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(payload)
  });
  if (!res.ok) {
    const text = await res.text().catch(() => '');
    let parsed;
    try {
      parsed = text ? JSON.parse(text) : null;
    } catch {
      parsed = null;
    }

    if (res.status === 403) {
      const err = new Error('אין הרשאה לבצע סנכרון – נדרש משתמש אדמין.');
      err.status = res.status;
      throw err;
    }

    if (res.status === 400) {
      const err = new Error(
        (parsed && parsed.message) || 'גוף הבקשה אינו תקין'
      );
      err.status = res.status;
      err.issues = (parsed && parsed.issues) || [];
      throw err;
    }

    const err = new Error(
      (parsed && parsed.message) || text || `שגיאת שרת (${res.status})`
    );
    err.status = res.status;
    throw err;
  }
  return res.json();
}
